import KidsContainer from 'components/Kids/KidsContainer'
import KidsPresentation from 'components/Kids/KidsPresentation'
import KidsData from 'components/Kids/KidsData'

export default {
  Container: KidsContainer,
  Presentation: KidsPresentation,
  Data: KidsData,
}
